import { Link } from 'react-router-dom';
import { Menu as MenuIcon, X } from 'lucide-react';
import { Button } from './ui/button';
import { DrawerTitle } from './ui/drawer';

const menuLinks = [
  { label: 'Home', path: '/' },
  { label: 'Shop All', path: '/shop' },
  { label: 'Motorcycles', path: '/motorcycles' },
  { label: 'Hot Deals', path: '/shop?hotDeal=true' },
];

export default function MenuDrawer({ onClose }) {
  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center justify-between px-4 pt-4">
        <div className="flex items-center gap-2">
          <MenuIcon className="h-5 w-5 text-foreground" />
          <DrawerTitle>Menu</DrawerTitle>
        </div>
        <Button variant="ghost" size="sm" onClick={onClose}>
          <X className="h-4 w-4" />
        </Button>
      </div>

      <div className="px-4 py-6 space-y-2">
        {menuLinks.map((link) => (
          <Link
            key={link.path}
            to={link.path}
            onClick={onClose}
            className="block px-4 py-3 text-lg font-medium text-foreground hover:bg-muted rounded-md transition-colors"
          >
            {link.label}
          </Link>
        ))}
      </div>

      <div className="mt-auto px-4 py-4 border-t border-border">
        <div className="px-4 py-2 text-sm text-muted-foreground">
          Linduska Moto Co.
        </div>
        <div className="px-4 py-1 text-xs text-muted-foreground">
          &copy; {new Date().getFullYear()} All rights reserved.
        </div>
      </div>
    </div>
  );
}
